// ROUTE CODE EDITED 09/15/2026
/**
 * Route Widget Version Override — App Embed / Snappy v3 (pure platform UI path)
 *
 * For merchants on pure App Embed with no route-div. Config is delivered via
 * GET /v1/protect/merchants/{id}/widgets/active and cached in ROUTE_WIDGET_CACHE
 * (localStorage, React Query persisted store). No sessionStorage or XHR
 * interception is needed.
 *
 * WHY configuration.cta.checkout.style_preset IS REQUIRED FOR PC EQ
 * -----------------------------------------------------------------
 * resolveDisplayWidget() injects style_preset: 'stacked-premium' automatically,
 * but only when widget_version does NOT include 'preferred-checkout'. Since
 * 'preferred-checkout-embedded-quote' contains that substring, the fallback
 * skips and the stacked premium layout never applies. Without style_preset,
 * cloneButtonHelpers falls to the else branch, reads checkout_cta_text as
 * static text, and the embedded quote never renders.
 *
 * The CONFIG_PATCH below is deep-merged into the configuration object so
 * existing ET fields (checkout_cta_text, mode, alignment, etc.) are preserved.
 * checkout_cta_text is still used as the main button text in the stacked layout.
 *
 * CONFIRMED PRECONDITIONS FOR THIS SCRIPT
 * ----------------------------------------
 * - Pure App Embed, no route-div in theme
 * - All Amplitude widget experiments returning key: "off"
 *   (if any flag returns non-off, useGetActiveWidget is disabled and this
 *   script will have no effect)
 *
 * USAGE
 * -----
 * Set TARGET_VERSION and CONFIG_PATCH below and inject before the App Embed
 * widget script. Top of <head>, no defer, no async.
 * Recommended: Resource Override rule injecting this file before
 * shopify-widget.route.com/shopify.widget.js.
 *
 * VALID TARGET_VERSION VALUES (BaseWidgetVersions)
 * -------------------------------------------------
 *   'preferred-checkout'
 *   'preferred-checkout-embedded-quote'
 *   'preferred-checkout-embedded-quote-returns'
 *   'preferred-checkout-returns'
 *   'preferred-checkout-cashback'
 *   'preferred-checkout-minimal'
 *   'preferred-checkout-opt-in'
 *   'optimal'
 *   'optimal-checkout-page-with-disclaimer'
 *   'optimized-block'
 *   'toggle'
 *   'carbon-toggle'
 *   'returns'
 *   'saas'
 *   'default'
 *   'green-pan'
 */

(function () {
  'use strict';

  // ─── CONFIGURE HERE ───────────────────────────────────────────────────────

  var TARGET_VERSION = 'preferred-checkout-embedded-quote';

  /**
   * Deep-merged into configuration after the version patch.
   * Required for any PC EQ variant — style_preset gates the stacked premium
   * layout that embeds the Route quote into the cloned checkout button.
   *
   * For plain PC (no embedded quote), set CONFIG_PATCH to {}.
   * For PC EQ Returns, keep style_preset and change TARGET_VERSION above.
   */
  var CONFIG_PATCH = {
      cta: {
        checkout: {
          style_preset: 'stacked-premium', // only valid value, remove for non-EQ
          text: 'CHECKOUT',  // main button text (overrides checkout_cta_text)
          subtext: 'Package Protection',   // stacked layout suffix (overrides version-driven default)
        },
        secondary: {
          text: 'Checkout without coverage',
          is_button: false,                 // renders as button instead of link
        },
      },
      mode: 'light',                       // 'light' | 'dark'
      alignment: 'left',                   // 'left' | 'center' | 'right'
    };
  // ──────────────────────────────────────────────────────────────────────────

  var CACHE_KEY        = 'ROUTE_WIDGET_CACHE';
  var API_PATTERN      = /api(?:-stage)?\.route\.com\/v1\/protect\/merchants\/[^/?#]+\/widgets\/active/;
  var QUERY_KEY_PREFIX = 'getActiveWidget';

  // ── Deep merge utility ────────────────────────────────────────────────────
  // Arrays are replaced, not concatenated. Does not mutate source.

  function deepMerge(target, source) {
    if (!source || typeof source !== 'object') return target;
    if (!target || typeof target !== 'object') return source;
    Object.keys(source).forEach(function (key) {
      var src = source[key];
      var tgt = target[key];
      if (
        src !== null && typeof src === 'object' && !Array.isArray(src) &&
        tgt !== null && typeof tgt === 'object' && !Array.isArray(tgt)
      ) {
        target[key] = deepMerge(tgt, src);
      } else {
        target[key] = src;
      }
    });
    return target;
  }

  // ── Shared patch helper ───────────────────────────────────────────────────

  function patchWidgetData(data) {
    if (!data) return data;
    var changed = [];

    if (data.widget_version !== TARGET_VERSION) {
      changed.push('widget_version: ' + data.widget_version + ' → ' + TARGET_VERSION);
      data.widget_version = TARGET_VERSION;
    }

    if (!data.configuration) data.configuration = {};

    if (Object.keys(CONFIG_PATCH).length) {
      deepMerge(data.configuration, JSON.parse(JSON.stringify(CONFIG_PATCH)));
      changed.push('config patch applied: ' + JSON.stringify(CONFIG_PATCH));
    }

    if (changed.length) {
      console.log('[RouteOverride] ' + changed.join(' | '));
    }

    return data;
  }

  // ── 1. Patch localStorage cache (warm cache path) ─────────────────────────
  // React Query persists the API response in ROUTE_WIDGET_CACHE. If the cache
  // is warm, useGetActiveWidget never makes a network call. Patch it first so
  // the widget reads the overridden version without needing a fetch.

  (function patchLocalStorageCache() {
    var raw;
    try {
      raw = localStorage.getItem(CACHE_KEY);
    } catch (e) {
      return;
    }

    if (!raw) return;

    try {
      var cache   = JSON.parse(raw);
      var queries = cache && cache.clientState && cache.clientState.queries;

      if (!Array.isArray(queries)) {
        localStorage.removeItem(CACHE_KEY);
        console.log('[RouteOverride] ROUTE_WIDGET_CACHE unexpected shape — cleared.');
        return;
      }

      var patched = false;
      queries.forEach(function (entry) {
        var key = entry && entry.queryKey;
        if (!Array.isArray(key) || key[0] !== QUERY_KEY_PREFIX) return;

        var data = entry && entry.state && entry.state.data;
        if (!data) return;

        patchWidgetData(data);
        patched = true;
      });

      if (patched) {
        localStorage.setItem(CACHE_KEY, JSON.stringify(cache));
      }
    } catch (e) {
      try { localStorage.removeItem(CACHE_KEY); } catch (_) {}
      console.warn('[RouteOverride] ROUTE_WIDGET_CACHE parse failed — cleared.', e);
    }
  })();

  // ── 2. Intercept fetch (cold cache path) ──────────────────────────────────
  // Covers the first load after cache expiry (3-hour TTL) or a cleared cache.
  // The SDK runs Zod validation (baseWidgetVersionSchema) on the response, so
  // TARGET_VERSION must be a valid BaseWidgetVersions string.

  var _origFetch = window.fetch;

  window.fetch = function (input, init) {
    var url = typeof input === 'string'
      ? input
      : (input && typeof input.url === 'string' ? input.url : '');

    if (!API_PATTERN.test(url)) {
      return _origFetch.apply(this, arguments);
    }

    return _origFetch.apply(this, arguments).then(function (response) {
      return response.clone().json().then(function (json) {
        patchWidgetData(json);

        var headers = {};
        response.headers.forEach(function (v, k) { headers[k] = v; });
        headers['content-type'] = 'application/json';

        return new Response(JSON.stringify(json), {
          status: response.status,
          statusText: response.statusText,
          headers: headers,
        });
      }).catch(function () { return response; });
    });
  };

  console.log(
    '[RouteOverride] Active — target: ' + TARGET_VERSION +
    ' | config patch: ' + JSON.stringify(CONFIG_PATCH)
  );
})();
// END ROUTE CODE